import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { get } from 'lodash'
import { Modal } from 'containers/misc'
import { Button } from 'components/misc'
import { form, permissions } from 'helpers/decorators'
import { Select } from 'components/fields'
import { PARTICIPANTS_BULK, ROLES } from 'constants/enums'
import { compose } from 'recompose'
import { apiAwards, apiCommon, apiLeaders, apiOrganizations } from 'helpers/decorators/api'
import { connect } from 'react-redux'
import { organizationsCodeListDropdownSelector } from 'redux/selectors/organizations'
import { leadersDropdownSelector } from 'redux/selectors/leaders'
import { modal } from 'redux/modules/app'
import { getActiveRole } from 'utils/token'
import { validateAuChange } from 'models/participants'

const enhance = compose(
  apiCommon(),
  permissions(),
  apiOrganizations({
    codeList: true,
    filter: 'awardUnitsOrIacs',
    minimal: true,
    disableLimit: true
  }),
  apiLeaders({
    filter: 'awardUnitLeaders',
    list: true,
    disableQueryFilter: true
  }),
  apiAwards({
    updateParticipantDetail: true
  }),
  connect(
    state => ({
      dropdownOrganizations: organizationsCodeListDropdownSelector(state),
      dropdownLeaders: leadersDropdownSelector(state)
    }),
    {
      modal
    }
  ),
  form({
    form: 'bulk-action-participant-transfer-modal',
    validate: validateAuChange
  })
)

class AwardUnitChangeModal extends Component {
  static propTypes = {
    modalId: PropTypes.string.isRequired,
    modal: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    values: PropTypes.object.isRequired,
    submitting: PropTypes.bool,
    dropdownOrganizations: PropTypes.array.isRequired,
    dropdownLeaders: PropTypes.array.isRequired,
    organizations: PropTypes.object,
    activeOrganization: PropTypes.object,
    leaders: PropTypes.object,
    getLeaders: PropTypes.func,
    getOrganizationCodeList: PropTypes.func,
    common: PropTypes.object,
    fetchCountriesWithStructure: PropTypes.func.isRequired,
    selectedIds: PropTypes.array,
    bulkProcess: PropTypes.func,
    bulkSetResult: PropTypes.func,
    handleError: PropTypes.func,
    permissions: PropTypes.object
  }

  static defaultProps = {
    values: {}
  }

  componentDidMount() {
    if (this.isSuperUser) {
      let filterCase = ''

      let filterId = ''

      switch (getActiveRole(this.props.activeOrganization)) {
        case ROLES.IF_REGION.u:
          filterCase = 'regionCountries'
          filterId = this.props.activeOrganization.regionId
          break

        default:
          break
      }

      this.props.fetchCountriesWithStructure({ filterCase, filterId })
    }

    const { permissions: appPermissions } = this.props

    if (appPermissions.isLeader) {
      this.props.activeOrganization && this.handleAuSelect(this.props.activeOrganization.id)
      this.props.activeOrganization && this.props.getLeaders(this.props.activeOrganization.id, { onlyActive: true })
    }
  }

  getCountryList = () => {
    let countriesList = this.props.common.countries.list

    switch (getActiveRole(this.props.activeOrganization)) {
      case ROLES.GBT.u:
        countriesList = this.props.common.ics.list
        break
      default:
        break
    }

    return countriesList
  }

  handleFetchAwardUnits = (obj = {}) => {
    this.props.getOrganizationCodeList({
      filterById: obj.value,
      filterCase: 'countryAwardUnitsOrIacs',
      isMinimal: true,
      disableLimit: true,
      resetFilter: true
    })
  }

  handleAuSelect = ({ value }) =>
    this.props.getLeaders(value, { onlyActive: true })

  handleBulkTransferParticipantsApprove = fields => {
    const bulkType = PARTICIPANTS_BULK.transferParticipants.id

    this.props.bulkProcess(this.props.selectedIds, bulkType, { leaderId: fields.leaderId })
      .then(data => {
        this.props.bulkSetResult(data.body)
        this.props.modal(null)
        this.props.modal('bulk-change-participants-results-modal')
      })
      .catch(this.props.handleError)
  }

  isSuperUser = getActiveRole(this.props.activeOrganization) ===
    ROLES.IF_STAFF_SUPER.u ||
    getActiveRole(this.props.activeOrganization) === ROLES.GBT.u ||
    getActiveRole(this.props.activeOrganization) === ROLES.OA.u ||
    getActiveRole(this.props.activeOrganization) === ROLES.SOA.u ||
    getActiveRole(this.props.activeOrganization) === ROLES.IF_REGION.u

  render() {
    const {
      modalId,
      values,
      submitting,
      dropdownOrganizations,
      dropdownLeaders,
      organizations,
      leaders,
      handleSubmit,
      common,
      permissions: appPermissions,
    } = this.props

    const countriesList = this.getCountryList()

    return (

      <Modal id={modalId} modal={modal} customActions enableOverflow>
        <form onSubmit={handleSubmit(this.handleBulkTransferParticipantsApprove)}>
          {this.isSuperUser &&
          <div className="row">
            <div className="col-xs-12">
              <Select
                label="Country"
                name="countryId"
                intlKey="label.country"
                onSelectChange={this.handleFetchAwardUnits}
                options={countriesList}
                loading={common.loading}
                searchable
              />
            </div>
          </div>}

          <div className="row">
            {!appPermissions.isLeader && <div className="col-xs-6">
              <Select
                label="Award unit"
                name="awardUnitId"
                intlKey='label.award_unit!'
                options={dropdownOrganizations}
                onSelectChange={this.handleAuSelect}
                searchable
                disabled={this.isSuperUser && !values.countryId}
                loading={organizations.loading}
              />
            </div>}
            <div className="col-xs-6">
              <Select
                label="Leaders"
                name="leaderId"
                intlKey="label.leaders"
                options={dropdownLeaders}
                disabled={!appPermissions.isLeader && !get(values, 'awardUnitId')}
                searchable
                loading={leaders.loading}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-6">
              <Button
                secondary
                type="button"
                intlKey="button.close"
                onClick={() => this.props.modal(null)}
              >
                Close
              </Button>
            </div>
            <div className="col-xs-6 text--right">
              <Button
                intlKey="button.change"
                isLoading={submitting}
                disabled={!get(values, 'leaderId')}
                onClick={() => this.props.modal(null)}
              >
                Change
              </Button>
            </div>
          </div>
        </form>
      </Modal>
    )
  }
}

export default enhance(AwardUnitChangeModal)
